<template>
  <client-only>
    <etg-img
      :src="avatar"
      alt="fail to fetch image"
      :width="avatarSize"
      :height="avatarSize"
      class="aspect-square rounded-full object-cover"
      :class="avatarClasses"
      :use-webp="!fbAvatar"
    />
    <template #fallback>
      <n-skeleton :width="avatarSize" :height="avatarSize" class="mx-auto rounded-full" />
    </template>
  </client-only>
</template>

<script lang="ts" setup>
import { NSkeleton } from 'naive-ui'

import { useAuthStore } from '@/store/auth'
import { useAppStore } from '@/store/app'
import { EdbMemberAuthType } from '@/types/api'

interface Props {
  isNavbar?: boolean
}

const props = defineProps<Props>()

const appStore = useAppStore()
const authStore = useAuthStore()

const { isLogin, user } = storeToRefs(authStore)

const fbAvatar = computed(() => {
  const fbId = user.value?.account
  const isFbLogin = user.value?.auth_type === EdbMemberAuthType.MemberAuthTypeFB
  return fbId && isFbLogin ? `https://graph.facebook.com/v22.0/${fbId}/picture?type=large&width=240&height=240` : ''
})
const avatarClasses = computed(() => [fbAvatar.value ? 'ring-2 ring-red-50' : ''].concat(props.isNavbar ? '' : 'mx-auto'))
const avatar = computed(() => {
  const DEFAULT_AVATAR = isLogin.value ? '/images/avatar-member.png' : '/images/avatar-guest.png'
  return fbAvatar.value || DEFAULT_AVATAR
})
const avatarSize = computed(() => {
  if (!props.isNavbar) {
    return 120
  }

  return appStore.isMobile ? 60 : 48
})
</script>
